'use strict';

import angular from 'angular';
import ListController from './list.controller';

export default angular.module('updateServerApp.categories.list', [])
  .controller('CategoriesListController', ListController)
  .name;



// WEBPACK FOOTER //
// ./client/app/categories/list/index.js